/**
 * MoonLoader — o loader-assinatura: a lua atravessa as fases (minguante →
 * cheia) em loop. Substitui spinners genéricos nos carregamentos de área.
 */
import { cn } from '../../lib/utils';

export function MoonLoader({ size = 28, className, label }: { size?: number; className?: string; label?: string }) {
  return (
    <span className={cn('inline-flex flex-col items-center gap-2.5', className)} role="status" aria-live="polite">
      <span
        className="moon-loader block rounded-full"
        style={{ width: size, height: size }}
        aria-hidden
      />
      {label && (
        <span className="font-mono text-[9px] uppercase tracking-[0.24em] text-muted-foreground">{label}</span>
      )}
    </span>
  );
}
